import * as React from 'react'

const MS_PER_DAY = 86_400_000

const nextUtcMidnight = (nowMs: number): number => Math.floor(nowMs / MS_PER_DAY) * MS_PER_DAY + MS_PER_DAY

/** `Date.now()` as state, re-read at UTC midnight, so a clock-derived memo can take it as a dep. */
export const useUtcDayClock = (): number => {
  const [nowMs, setNowMs] = React.useState(() => Date.now())

  React.useEffect(() => {
    let timer: ReturnType<typeof setTimeout>
    const arm = () => {
      // Re-armed off the woken clock, not by adding a day: a late fire would walk the boundary.
      timer = setTimeout(
        () => {
          const wokeAt = Date.now()
          setNowMs(wokeAt)
          arm()
        },
        Math.max(1, nextUtcMidnight(Date.now()) - Date.now())
      )
    }
    arm()
    return () => clearTimeout(timer)
  }, [])

  return nowMs
}

/** The clock's UTC day. A query key can take this: it changes at rollover and not per mount. */
export const useUtcDayIndex = (): number => Math.floor(useUtcDayClock() / MS_PER_DAY)
